import { IconButton, styled } from '@presov.sk/presov-ui-react';

export const HeaderIconButton = styled(IconButton)(({ theme }) => ({
  border: 'none',
  borderRadius: '100%',
  background: 'transparent',
  '&:hover': {
    background: theme.palette.primary.light,
  },
  '&:active': {
    background: theme.palette.primary.dark,
  },
}));
